import Colors from '@legacy/common/Constants/Colors'
import styled from 'styled-components'

export const ProjectHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${Colors.primary.lightGray};
    padding-bottom: 2rem;
`